var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('van-nav-bar',{attrs:{"title":"征稿启事","left-arrow":"","fixed":true},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.info.notice)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }